import { ButtonStyled } from './styled'

const ButtonColor = ({
  textColor,
  bgColor,
  handleClick,
  children,
  ...props
}) => (
  <ButtonStyled
    onClick={() => handleClick(bgColor)}
    textColor={textColor}
    bgColor={bgColor}
    {...props}
  >
    {children}
  </ButtonStyled>
)

export default ButtonColor
